module.exports = __webpack_public_path__ + "img/demo-2.594efc32.png";